import { createContext } from "react";

/**
 * Provides the element beside the page's content card that a page may render into with a portal.
 *
 * Postconditions: Null when the layout has no page aside, such as below the md breakpoint or in the
 * legacy layout; pages then render that content within the card instead.
 */
const PageAsideContext = createContext<HTMLElement | null>(null);

export default PageAsideContext;
